export function cleanLinkData(value: any = {}): any {
  return Object.fromEntries(Object.entries(value).filter((e) => e[1] !== ''));
}
